import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import AddCashLoanLayer from "../../../components/Admin/AddCashLoanLayer";

const AddCashLoan = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <AddCashLoanLayer />
      </MasterLayout>
    </>
  );
};

export default AddCashLoan;
